import React, { useState, useEffect, useMemo, useRef } from "react";
import eventClasses from "./locationcontrols.module.scss";
import classes from "../../controls.module.scss"
import {
    FormControlLabel,
    FormControl,
    TextField,
    Button,
    Grid,
    Modal,
    Box,
    Typography
} from '@mui/material';
import {Checkbox, Dialog} from "@genesis/ui-kit";
import { AddPlusIcon } from "../../../../Resources/availabilityicon/IconUtils";
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import useToggle from "@genesis/ui-kit/dist/hooks/useToggle";
import { Navigate, useLocation } from "react-router-dom";
import NotificationView from "../../../../Shared/Notification/NotificationView";
import { useNavigate, NavLink } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "./DivisionDropdownComp";
import duplicate from "../../../../Resources/duplicate.png";
import deleteimg from "../../../../Resources/delete.png";
import add from "../../../../Resources/add.png";
import add_disable from "../../../../Resources/add_disable.png";
import duplicate_disable from "../../../../Resources/duplicate_disable.png";
import delete_disable from "../../../../Resources/delete_disable.png";
import DeleteEventDialog from "./DeleteEventDialog";
import DuplicateEventDialog from "./DuplicateEventDialog";
import { AllControlSearchView } from "../RuleAssignments/Search/RuleAssignmentsSearch";
import { isString } from '../../../../Shared/Utill/Utills';
import Edit from "./Edit";
import PreferenceGroupsGrid from "./PreferenceGroupsGrid";


const AddEditLocationControls = (props) => {

    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const token = Cookie.get('X_TKN');
    const dialog = useToggle();
    const locDialog = useToggle();
    const location = useLocation();
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const [division, setDivision] = React.useState("");
    const [isActive, setIsActive] = React.useState("");
    const [weeksOut, setWeeksOut] = React.useState("");
    const [dropDownIncrement, setIncrement] = React.useState("");
    const [storeLocation, setStoreLocation] = React.useState("");
    const [storeActive,setStoreActive] = React.useState(false)
    const [newHire,setNewHire] = React.useState("")
    const [newHireActive,setNewHireActive] = React.useState(false);
    const [workSchedule,setWorkSchedule] = React.useState("")
    const [workActive,setWorkActive] = React.useState(false);

    console.log("data from search parent!"+ JSON.stringify(location.state.data))
    const [eventBaseData, setEventBaseData] = React.useState(location.state.data);
   /* const [storeActive,setStoreActive] = React.useState(eventBaseData.store_status === "Active"||true)
    const [newHireActive,setNewHireActive] = React.useState(eventBaseData.newhire_status === "Active"||true);
    const [workActive,setWorkActive] = React.useState(eventBaseData.workschedule_status === "Active"||true); */
    console.log("checking NewHireActive variable " + newHireActive)
    const [flag, setFlag] = React.useState(location.state.flag);
    const history = useNavigate();
    const [prefApiData, setprefApiData] = React.useState(null);
    const { message, severity, open } = isAlertOpen || {};
    const [readOnlyView, setReadOnly] = React.useState(false);
    const [ongoingActionCompleted, setOngoingActionCompleted] = React.useState(true);
    const [activateEvent, setActivateEvent] = React.useState(true)
    const [useBaseData, setUseBaseData] = useState(true);
    const [useApiData, setUseApiData] = useState(true);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openDuplicateDialog, setOpenDuplicateDialog] = useState(location.state.copy||false);
    const [prefDetails,setPrefDetails] = useState([]);
    const [duplicateFlag,setDuplicateFlag] = useState(location.state.dup||"S")
    const [isFromSearch,setIsFromSearch] = useState(location.state.isSearch || false);


    // Modal 
    const [open2, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

     // Add
     const [eventName, setEventName] = React.useState("");
     //cancel editing
     const [cancelFlag, setCancelFlag] = React.useState(false);
     // checking if component is unmounted
     const componentMounted = useRef(true);
     console.log("this needs to be " + openDuplicateDialog);
     console.log("flag is "+duplicateFlag)

     useEffect(() => {
        if(duplicateFlag === "D") {
            setReadOnly(false);
        }
        if ((eventBaseData !== null) && (eventBaseData !== undefined)) {
            console.log(flag)
            console.log("what data do i have", location.state.data)
            console.log("checking prefdetails variable " + prefDetails.length)
            setUseBaseData(true);
            if (flag === 'E') {
                
                console.log("ongoing"+ongoingActionCompleted)
                
                if (useBaseData && ongoingActionCompleted) {
                    console.log("checking NewHireActive variable 2" + newHireActive)
                    console.log(eventBaseData)
                    setDivision(eventBaseData.divnbr)
                    //setWeeksOut(eventBaseData.weeksOut)
                    setStoreLocation(eventBaseData.prefLocation)
                   
                }
            }

            //getEventDetailsApi(); 
        } else if (!useApiData) {
            console.log(flag)
            // set flag to A
            setFlag("A");
            setUseBaseData(false);
            setReadOnly(false);
            setOngoingActionCompleted(false);
            //setprefApiData(null)
        }

    }, [ongoingActionCompleted, prefApiData, eventBaseData,prefDetails]);


    useEffect(() => {
        if ((flag === "E") && (prefApiData == undefined)) {
            setUseBaseData(false)
            if(eventBaseData && eventBaseData.prefLocation === 0 && location.state.dup === undefined){
                locDialog.show();
            }
        }

        if ((flag === "E") && (prefApiData == undefined) && (ongoingActionCompleted) && (eventBaseData !== undefined)) {
            getLocationControls(eventBaseData.division,eventBaseData.divnbr,eventBaseData.prefLocation,eventBaseData.locid,eventBaseData.appid)
            getLocalControlsPreferences(eventBaseData.divnbr,eventBaseData.prefLocation)
           // getEventApi()
        }

    }, [flag]);

    //number validation
    const checkForNumber = (input) => {
        if (typeof input === "number") {
            return true;
        } else {
            return false;
        }

    }

    const onDivDropDownSelect = (selectedDivision) => {
        // setDivSelectedValue(selectedDivision);
        console.log(division)
        if (selectedDivision !== null && selectedDivision !== undefined) {
            console.log(selectedDivision)
            console.log(selectedDivision.divNbr);
            setDivision(selectedDivision.divNbr);
        }
    }

    const resetForAdd = () => {
        if (ongoingActionCompleted && !openDuplicateDialog ) {
            console.log("SETUP FOR ADD")
            setOpenDuplicateDialog(false)
            setOpenDeleteDialog(false)
            setUseApiData(true)
            setUseBaseData(false)
            setActivateEvent(true)
            setOngoingActionCompleted(true)
            setReadOnly(false)
            setprefApiData(null)
            setDivision("")
            setStoreLocation("")
            setIncrement("")
            setWeeksOut("")
            setNewHire("")
            setWorkSchedule("")
            setStoreActive(false)
            setWorkActive(false)
            setNewHireActive(false)
            setFlag("A")
            //alert("WE LIT")
            history([-1,'/controls/availabilityapplicationcontrols/locationcontrols/Add', { state: true }])
            
        } else {
            console.log("not ready to click add")
        }

            
    }

    const onDeleteCallback = (responseType, message) => {
        console.log("THIS IS THE ISSUE"+ message)
        onCloseDialog();
        //handle success / failue
        setAlertOpen({
            open: true,
            severity: responseType,
            message: message,
        });
        // refresh data
        if (responseType == 'success') {
            // navigate back to event search page
            
            history('/controls/availabilityapplicationcontrols/locationcontrols', { state: {message: message,isDelete: true }});
        }
    }

    const onDuplicateCallback = (responseType, message, resp) => {
        onCloseDialog();
        //handle success / failue
        setAlertOpen({
            open: true,
            severity: responseType,
            message: message,
        });
        setFlag("E");
        setEventName(resp.eventName);
        setWeeksOut(resp.weeksOut);
        //: refresh page data to load data
        // getPreferencesApi(division,resp.eventName); // not required to refresh

    }

    const onCloseDialog = () => {
        setOpenDeleteDialog(false);
        setOpenDuplicateDialog(false);
        setDuplicateFlag("")

 }

    const onDeleteAction = () => {
        setOpenDeleteDialog(true);
    }

    const onDuplicateAction = () => {
        setReadOnly(false)
        setOpenDuplicateDialog(true);
        setDuplicateFlag("D")
        history("/controls/availabilityapplicationcontrols/locationcontrols/Duplicate", {
            state: {flag: "D",dup:"D"},
          });
    }

    const handleAlertNotifClose = () => {
        setAlertOpen({});
    };

    const handleCancel = () => {
        if(duplicateFlag === "D" && isFromSearch){
            history('/controls/availabilityapplicationcontrols/locationcontrols');
            return;
        } 
        if(flag === "A" && !isFromSearch){
            setOngoingActionCompleted(true);
            // call api to reset values
            setOpenDuplicateDialog(false)
            makeReadOnly(); 
            setFlag("E");
            //history.back();
            history('/controls/availabilityapplicationcontrols/locationcontrols/Edit', {  state: {flag: "E", id: location.state.id, data:location.state.data}});
            return;
        }
        
        if (flag === "E") {
            setOngoingActionCompleted(true);
            // call api to reset values
            setOpenDuplicateDialog(false)
            makeReadOnly(); 
        } else {
        history('/controls/availabilityapplicationcontrols/locationcontrols');
        }
    }

    const handleCheckBox = (props) => {
        if (props === "Active") {
            return true;
        } else if (props === "Inactive") {
            return false;
        }
    }

    const handleActives = (val,type) => {
        console.log("Handle Actives is working with " + val + " " + type)
        if (val === "y") {
            return true;
        } else if (val === "n") {
            return false;
        }
    }
   

    const makeEditable = () => {
        setReadOnly(false)
        setOngoingActionCompleted(false);
        
        console.log(readOnlyView + " ready only ")
        if (readOnlyView == true) {
            setReadOnly(false)
        }
    }
    const makeReadOnly = () => {
        //on click of save
        setOngoingActionCompleted(true);
        if (readOnlyView == false) {
            setReadOnly(true)
        }
    }

    const makeLocationActive = () => {
        if (storeActive == true) {
            
            setStoreActive(false)
        } else if (storeActive == false) {
            
            setStoreActive(true)
        }
    }

    const makeNewHireActive = (event) => {
        console.log("Debugging 1")
        if (newHireActive === true) {
            console.log("Debugging 2")
            setNewHireActive(event.target.checked)
            console.log(newHireActive)
        } else if (newHireActive === false) {
            console.log("Debugging 3")
            setNewHireActive(event.target.checked)
        }
    }

    const makeWorkScheduleActive = (event) => {
        if (workActive == true) {
            
            setWorkActive(false)
        } else if (workActive == false) {
            
            setWorkActive(true)
        }
    }


    const getLocationControls = async (DisplayDiv = null, div = null, loc = null, locId = null, appId = null) => {
        console.log(eventBaseData)
        let data = {
            displayDiv: DisplayDiv !== null ? DisplayDiv:eventBaseData.division,
            divNbr: div !== null ? div : eventBaseData.divnbr,
            locNbr: loc !== null ? loc : eventBaseData.prefLocation,
            locId: locId != null ? locId: eventBaseData.locid,
            appId: appId !== null ? appId: eventBaseData.appid
        }
        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_APP_CONTROL_GET_ADMIN_APP_LOCATION_CONTROLS}`,
            data,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then((response) => {
                console.log("response is", response.data)
                setDivision(response.data.divNbr)
                setStoreLocation(response.data.locNbr)
                setIncrement(response.data.avlShiftSelectXminsApart)
                setWeeksOut(response.data.wksout)
                setStoreActive(handleActives(response.data.active,"store 43"))
                setNewHire(response.data.newHireForXdays)
                setNewHireActive(handleActives(response.data.newHireActive,"newhire 43"))
                setWorkSchedule(response.data.workScheduleUnlocked)
                setWorkActive(handleActives(response.data.workScheduleActive,"workactive 43"))
                 if (componentMounted.current) {
                    setUseBaseData(false);
                    setprefApiData(response.data);
                    setReadOnly(true)
            }   componentMounted.current = false;
                
                if (ongoingActionCompleted) {
                    setUseApiData(true);
                    
                }
            })
            .catch((error) => {
                if (error.message === 'Network Error') {
                    history("/somethingwentwrong", { state: `Please logout and try again ` })
                }

            })
    }


    const getLocalControlsPreferences = async ( div = null, loc = null) => {
        console.log(eventBaseData)
        let data = {
            
            divNbr: div !== null ? div : eventBaseData.divnbr,
            locNbr: loc !== null ? loc : eventBaseData.prefLocation,
            
        }
        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_APP_CONTROL_GET_LOCAL_CONTROLS_PREFERENCES}`,
            data,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            })
            .then((response) => {
                console.log("response is for prepping preferences", response.data)
                
                let rows = []
                let a = 1;
                response.data.map( (e) =>  
                { 
                    //console.log(a)
                
                    let myObj = {};
                    myObj.id = a; 
                    myObj.pwhNbr = e.pwhNbr; 
                    myObj.pwhConfigured = e.preferencesConfigured;
                    myObj.locNbr = e.locNbr;
                    myObj.divNbr = e.divNbr;
                    rows.push(myObj)
                    a = a + 1
                } 
                )
                //setprefApiData(response.data);
                setPrefDetails(rows)
                if (componentMounted.current) {
                    setUseBaseData(false);
                    
                    setReadOnly(true)
                }
                componentMounted.current = false;
                
                if (ongoingActionCompleted) {
                    setUseApiData(true);
                    
                }
            })
            .catch((error) => {
                if (error.message === 'Network Error') {
                    history("/somethingwentwrong", { state: `Please logout and try again ` })
                }

            })
    }
    //check necessary props to send to duplicate.
    const copyStringForDuplicate = () => {
        //alert("this is being used to find "+ workActive)
        if(openDuplicateDialog) {
               // alert(storeLocation)
                return "_copy";
            } else {
                return "";
            }
    }

    const saveData = () => {
        console.log("WE ARE TRYING TO SAVE HERE")

        if (division === null) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Please Select Division",
            })
        }

        if (isString(division)) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Division should be numeric.",
            })

        }

        if (isString(storeLocation)) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Location should be numeric.",
            })

        }
        if (isString(weeksOut)) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "WeeksOut should be numeric.",
            })

        }

        if (isString(dropDownIncrement)) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "DropDown Increment should be numeric.",
            })

        }
        else {
            // Duplicate flow
            if (openDuplicateDialog && flag === "E") {

                let data = {
                    action:"D",
                    divNbr: division,
                    locNbr: storeLocation,
                    duplicateFromLocNbr: eventBaseData!==null ? eventBaseData.prefLocation:storeLocation,
                    active:storeActive ? "y":"n",
                    avlShiftSelectXminsApart: dropDownIncrement,
                    wksout:weeksOut,
                    newHireActive:newHireActive ? "y":"n",
                    newHireForXdays:newHire,
                    workScheduleActive:workActive ? "y":"n",
                    workScheduleUnlocked:workSchedule,
                    lastUpdatedBy: personDetails.emplID,
                };


                axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_APP_CONTROL_ADD_EDIT_ADMIN_APP_LOCATION_CONTROLS}`,
                        data, {
                            headers: {
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + token
                            }
                        })
                            .then((res) => {
                            console.log("response is",res.data);
                            setAlertOpen({
                                open: true,
                                severity: "success",
                                message: "Div " + division + " Loc " + storeLocation + " added succesfully."
                            })
                            setDuplicateFlag("S")
                            setReadOnly(true)
                            setOngoingActionCompleted(true)
                            setOpenDuplicateDialog(false);
                           // getPreferencesApi(division, storeLocation)
                           getLocationControls(
                            res.data.displayDiv,
                            res.data.divNbr,
                            res.data.locNbr,
                            res.data.locId,
                            res.data.appId
                            )
                            getLocalControlsPreferences(
                                res.data.divNbr,res.data.locNbr
                            ) 
                            setFlag("E")
                            //setDuplicateFlag("S")
                            setUseBaseData(false);
                            setEventBaseData(null);
                           
    
                        }).catch((err) => {
                            setAlertOpen({
                                open: true,
                                severity: "error",
                                message: err.response.data.message,
                            })
                        });
            }// DUPLICATE

            if (!openDuplicateDialog && flag === "E") {
                console.log("EDIT SAVE TEST")
                //console.log(division)
                //console.log(prefApiData)
                let data = {
                    action:"E",
                    divNbr: division,
                    locNbr: storeLocation,
                    active:storeActive ? "y":"n",
                    avlShiftSelectXminsApart: dropDownIncrement,
                    wksout:weeksOut,
                    newHireActive:newHireActive ? "y":"n",
                    newHireForXdays:newHire,
                    workScheduleActive:workActive ? "y":"n",
                    workScheduleUnlocked:workSchedule,
                    lastUpdatedBy: personDetails.emplID,
                }

                axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_APP_CONTROL_ADD_EDIT_ADMIN_APP_LOCATION_CONTROLS}`,
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token,
                        }
                    }).then((res) => {
                        // call api to fetch data     
                        console.log("WE ARE TRYING TO SAVE HERE EDIT")
                        setAlertOpen({
                            open: true,
                            severity: "success",
                            message: `Div ${res.data.divNbr} Loc ${res.data.locNbr} Saved successfully`,
                        })
                        makeReadOnly();
                       // getPreferencesApi(division, storeLocation)
                       getLocationControls(
                        res.data.displayDiv,
                        res.data.divNbr,
                        res.data.locNbr,
                        res.data.locId,
                        res.data.appId
                        )
                        getLocalControlsPreferences(
                            res.data.divNbr,res.data.locNbr
                        )
                       

                    }).catch((err) => {
                        setAlertOpen({
                            open: true,
                            severity: "error",
                            message: err.response.data.message,
                        })
                    });
                // EDIT 
            } 
                else if (flag === "A") {
                        console.log(storeActive)
                        console.log(division)
                        console.log("WORK MAN "+workActive)

                        let data = {
                            action:"A",
                            divNbr: division,
                            locNbr: storeLocation,
                            active:storeActive ? "y":"n",
                            avlShiftSelectXminsApart: dropDownIncrement,
                            wksout:weeksOut,
                            newHireActive:newHireActive ? "y":"n",
                            newHireForXdays:newHire,
                            workScheduleActive:workActive ? "y":"n",
                            workScheduleUnlocked:workSchedule,
                            lastUpdatedBy: personDetails.emplID,
                            
                        
                        }

                        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_APP_CONTROL_ADD_EDIT_ADMIN_APP_LOCATION_CONTROLS}`,
                            data,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + token,
                                }
                            }).then((res) => {
                                console.log("WE ARE TRYING TO SAVE HERE")
                                console.log(res)
                                setAlertOpen({
                                    open: true,
                                    severity: "success",
                                    message: `Div ${res.data.divNbr} Loc ${res.data.locNbr} Saved successfully`,
                                })

                                setReadOnly(true)
                                setOngoingActionCompleted(true)
                                getLocationControls(
                                    res.data.displayDiv,
                                    res.data.divNbr,
                                    res.data.locNbr,
                                    res.data.locId,
                                    res.data.appId
                                    )
                                getLocalControlsPreferences(
                                    res.data.divNbr,res.data.locNbr
                                )
                                setFlag("E")
                                setUseBaseData(false);
                                setEventBaseData(null);
                                
                                //setEventId(res.data.eventId)
                                //setDivision(res.data.divNbr)
                                //setEventName(res.data.eventName);

                            }).catch((err) => {
                                setAlertOpen({
                                    open: true,
                                    severity: "error",
                                    message: err.response.data.message,
                                })


                            });
                    }  // ADD 
                } // else end
            } // save end
    
    if (flag === "E") {
         // made so that when copying it won't change.
    return (
        <div className={eventClasses.pagemargin}>
                <AllControlSearchView />
                <Box>
                    <Dialog
                open={locDialog.open}
                title='Default Location 0'
                actions={
                <>
                    <Button onClick={locDialog.hide}>Ok</Button>
                </>
                }
            >
                <Typography>Note: Location 0 is the divisional default. All unconfigured locations will reflect these settings.</Typography>
            </Dialog>
            </Box>
                <div style={{ width: "100%" }}>

                    <div className="eventpagetitle" style={{ textAlign: "left", width: "45%" }} >
                    {openDuplicateDialog ? "Div " + (division|| (eventBaseData!== null ? eventBaseData.divnbr: division)) + " Loc " + ( eventBaseData!== null ? eventBaseData.prefLocation : storeLocation) + copyStringForDuplicate()  
                    : "Div " + (division) + " Loc " +  storeLocation}
                  
                    </div>
                    <div className="eventpagetitle2" style={{textAlign:"right", width:"55%",marginLeft:"-1.75%"}}>

                        <div className="eventicon2">
                                <div style={{ color: ongoingActionCompleted  ? "inherit" : "grey", display: "inline-block", marginLeft: "5px" }} >
                                    {(ongoingActionCompleted && !openDuplicateDialog ) && <AddPlusIcon type ={"black"}/> }
                                    {(!ongoingActionCompleted || openDuplicateDialog) && <AddPlusIcon type ={"grey"}/> }
                                    <NavLink
                                        onClick={resetForAdd}
                                        to='/controls/availabilityapplicationcontrols/locationcontrols/Add'
                                        style={{pointerEvents:(ongoingActionCompleted && !openDuplicateDialog ) ? "auto":"none" ,color: (ongoingActionCompleted && !openDuplicateDialog ) ? "inherit" : "grey", textDecoration: "underline", marginLeft: "5px" }}
                                        state={{ flag: "A", isSearch: false }}
                                        className={classes.label_text}>
                                        Add
                                    </NavLink>
                                </div>
                        </div>
                        <div  className="eventicon2" onClick={() =>(ongoingActionCompleted && !openDuplicateDialog ) ? onDuplicateAction() : null}>
                            <img height={20} width={20} className="images" src={(ongoingActionCompleted && !openDuplicateDialog ) ? duplicate: duplicate_disable}   />
                            <div  style={{ pointerEvents:(ongoingActionCompleted && !openDuplicateDialog ) ? "auto":"none" ,color : (ongoingActionCompleted && !openDuplicateDialog) ? "inherit" : "grey", display:"inline-block", marginLeft:"5px",cursor:"pointer",textDecoration:"underline"}} >
                                <div >
                                Duplicate 
                                </div>
                                
                        </div>
                        </div>
                        <div className="eventicon2" onClick={() =>(ongoingActionCompleted && !openDuplicateDialog ) ? onDeleteAction() : null}> 
                        <img className="images" src={(ongoingActionCompleted && !openDuplicateDialog ) ? deleteimg : delete_disable}   /> 
                            <span style={{pointerEvents:(ongoingActionCompleted && !openDuplicateDialog ) ? "auto":"none" ,color : (ongoingActionCompleted && !openDuplicateDialog )? "inherit" : "grey" , marginLeft:"5px",cursor:"pointer",textDecoration:"underline"}} >Delete</span> 
                        </div>    
                    </div>
                </div>
                <div className="editMessage">
                    <div className={eventClasses.editMessage}>
                    {(readOnlyView && !openDuplicateDialog) &&
                    <NotificationView 
                        message={"This is a 'Read-only' page. To make changes, click 'Edit' below."} 
                        severity="info"
                        specify = "infoEditParent"
                        />
                    }
                    </div>
                </div>

                <div className={classes.searchbox}>
                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>

                    <Grid container spacing={4} rowSpacing={4}>
                        <Grid key={0} item xs={1.98}>
                            <div className={eventClasses.eventDetails2}>Details </div>
                        </Grid>
                        <div className={eventClasses.preferenceFields}></div>
                        <Grid key={1} item xs={1.98}>

                            <DivisionDropDownComp
                                readOnly={true}
                                onDivChange={e => onDivDropDownSelect(e)}
                                preSelectDivNbr={division}>
                            </DivisionDropDownComp>
                        </Grid>
                        <Grid key={2} item xs={1.94}>
                            <FormControl style={{ minWidth: '100%' }}>
                                <TextField
                                    disabled={( (!openDuplicateDialog || duplicateFlag !== "D") || (readOnlyView && duplicateFlag !== "D"))}
                                    sx={{
                                            "& .MuiInputBase-input.Mui-disabled": {
                                                WebkitTextFillColor: "#000000",
                                            },
                                        }}
                                    inputProps={{ readOnly: readOnlyView && !openDuplicateDialog }}
                                    label="Location*"
                                    onChange={(e) => duplicateFlag !== "D" ? null:setStoreLocation(e.target.value)}
                                    value={storeLocation}
                                />
                            </FormControl>
                        </Grid>

                        <Grid key={3} item xs={1.99}>
                            <FormControl style={{ minWidth: '100%' }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="Dropdown X Mins Apart*"
                                    onChange={(e) => setIncrement(e.target.value)}
                                    value={dropDownIncrement}
                                />
                            </FormControl>
                        </Grid>
                        <Grid key={4} item xs={2}>
                        <FormControl style={{ minWidth: '100%' }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="Weeks Out*"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => setWeeksOut(e.target.value)}
                                    value={weeksOut}
                                />
                            </FormControl>
                        </Grid>
                        <Grid key={5} item xs={2}>

                        </Grid>
                        <Grid key={6} item xs={2}>
                        
                        </Grid>
                        <Grid  item xs={2}>
                        <FormControlLabel
                            value="top"
                            control={
                            <Checkbox
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 34 } }} 
                                onChange={makeLocationActive} 
                                checked =  {storeActive}
                                disabled = {readOnlyView}  
                             />
                             }
                            label="Location Active"
                            labelPlacement="end"
                            />
                        
                        </Grid>

                        <Grid key={7} item xs={12}></Grid>

                        <Grid item xs={2.02}>
                            <div className={eventClasses.eventDetails2}>New Hires Unlocked </div>
                        </Grid>

                        <Grid item xs={1.98} rowSpacing={2}>
                        <FormControl style={{ minWidth: '100%' }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="New Hire For X Days*"
                                    onChange={(e) => setNewHire(e.target.value)}
                                    value={newHire}
                                />
                            </FormControl>   
                        </Grid>
                        <Grid item xs={8} rowSpacing={2}>
                        </Grid>
                        <Grid item xs={2.02}>
                        </Grid>
                        <Grid item xs={1.98}>
                        <FormControlLabel
                            value="top"
                            control={
                            <Checkbox 
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 34 } }} 
                            onChange={makeNewHireActive} 
                            checked = {newHireActive}
                            disabled = {readOnlyView}  
                            />
                            }
                            label="New Hire Active"
                            labelPlacement="end"
                            />
                        </Grid>

                        <Grid item xs={8}>
                        
                        </Grid>
                        <Grid item xs={2.5} columnSpacing={{xs:1}}>
                        <div style={{whiteSpace:"nowrap",marginRight:"30%",fontSize:"25px",}} className={eventClasses.eventDetails2}>Work Schedules </div>
                        <div style={{marginTop:"-2px",marginRight:"30%",fontSize:"25px",}} className={eventClasses.eventDetails2}> Unlocked </div>
                        </Grid>

                        <Grid item xs={6} rowSpacing={2}>
                        <FormControl style={{ minWidth: '100%' ,marginLeft:"-8%" }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="Work Schedules*"
                                    onChange={(e) => setWorkSchedule(e.target.value)}
                                    value={workSchedule}
                                />
                            </FormControl>   
                        </Grid>
                        <Grid item xs={2.02} >
                        </Grid>
                        <Grid item xs={2.02} >
                        </Grid>
                        <Grid item xs={1.98} >
                        <FormControlLabel
                            value="top"
                            control={
                            <Checkbox 
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 34 } }} 
                            onChange={makeWorkScheduleActive} 
                            checked = {workActive}
                            disabled = {readOnlyView}  
                            />
                            }
                            label="Work Schedule Active"
                            labelPlacement="end"
                            />
                        </Grid>
                        <Grid item xs={12} >
                        </Grid>
                    </Grid>
                    
                    <Grid container spacing={4} rowSpacing={6}>
                        <Grid item xs={2} columnSpacing={{xs:1}}>
                            <div className={eventClasses.eventDetails2}> Preference Groups </div>
                        </Grid>
                        <Grid 
                            item xs={9.5} 
                            columnSpacing={{xs:1}} 
                            sx={
                                { 
                                    
                                    minHeight: '900px', 
                                } 
                               }>
                           {prefDetails.length > 1 && <PreferenceGroupsGrid data = {prefDetails} readOnlyView={readOnlyView}/> }
                        </Grid>
                    <Grid item xs={12}>
                        
                    </Grid>
                    </Grid>


                    <Grid container spacing={4} rowSpacing={6}>
                        <Grid key={8} item xs={4}></Grid>
                        <Grid key={9} item xs={2}></Grid>
                        
                            
                       
                        <Grid key={10} item xs={1.99}>
                        { (!readOnlyView || openDuplicateDialog) && 
                            <Button 
                                onClick={handleCancel} 
                                color="secondary" 
                                size="large" 
                                style={{
                                minWidth: '100%',
                                minHeight: '120%',
                            }}>
                                Cancel
                            </Button> }
                        </Grid>
                        <Grid key={11} item xs={2}>
                        {(!readOnlyView || openDuplicateDialog) &&
                            <Button 
                                color="primary" 
                                size="large" 
                                style={{
                                minWidth: '100%',
                                minHeight: '120%',
                            }} onClick={saveData}>
                                Save
                            </Button>}{ readOnlyView && (
                                <Button 
                                sx={{ 
                                minWidth: '100%',
                                minHeight: '120%', }} 
                                color="primary" 
                                onClick={makeEditable} >
                                Edit
                                </Button> 
                            ) }
                        </Grid>
                        <Grid item xs={12}></Grid>
                    </Grid>


                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>
                    {openDeleteDialog && <DeleteEventDialog onCloseDialog={onCloseDialog} onDeleteCallback={onDeleteCallback} divNbr={division} locNbr={storeLocation} pwhGrpNbr = {1} />}
                    

                </div>
        </div>

        
    )
    } else if (flag === "A") {
        return (
            <div className={eventClasses.pagemargin}>
                <AllControlSearchView />
                <div style={{ width: "100%" }}>

                    <div className="eventpagetitle" style={{ textAlign: "left", width: "45%" }} >{"Add"}</div>
                    <div className="eventpagetitle2" style={{ textAlign: "right", width: "55%",marginLeft:"-1.75%" }}>

                        <div className="eventicon2">
                                <div style={{ color: ongoingActionCompleted  ? "inherit" : "grey", display: "inline-block", marginLeft: "5px" }} >
                                    {!ongoingActionCompleted && <AddPlusIcon type ={"black"}/> }
                                    {ongoingActionCompleted && <AddPlusIcon type ={"grey"}/> }
                                    <NavLink
                                        onClick={resetForAdd}
                                        to={"./"}
                                        style={{ pointerEvents:(!ongoingActionCompleted && eventBaseData) ? "auto":"none", color: (!ongoingActionCompleted) ? "inherit" : "grey", textDecoration: "underline", marginLeft: "5px" }}
                                        state={{ flag: "A" }}
                                        className={classes.label_text}>
                                        Add
                                    </NavLink>
                                </div>
                        </div>
                        <div  className="eventicon2" onClick={() => (!ongoingActionCompleted  ) ? onDuplicateAction() : null}>
                            <img height={20} width={20} className="images" src={(!ongoingActionCompleted ) ? duplicate: duplicate_disable}   />
                            <div  style={{ pointerEvents:(!ongoingActionCompleted && eventBaseData  ) ? "auto":"none" ,color : (!ongoingActionCompleted) ? "inherit" : "grey", display:"inline-block", marginLeft:"5px",cursor:"pointer",textDecoration:"underline"}} >
                                <div >
                                Duplicate 
                                </div>
                                
                            </div>
                        </div>
                        <div className="eventicon2" onClick={() => !ongoingActionCompleted ? onDeleteAction() : null}> 
                        <img className="images" src={!ongoingActionCompleted ? deleteimg : delete_disable}   /> 
                            <span style={{pointerEvents:(!ongoingActionCompleted && eventBaseData ) ? "auto":"none" ,color : !ongoingActionCompleted ? "inherit" : "grey" , marginLeft:"5px",cursor:"pointer",textDecoration:"underline"}} >Delete</span> 
                        </div>    
                    </div>
                </div>
                 
                    <div className={classes.searchbox}>
                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>

                    <Grid container spacing={4} rowSpacing={4}>
                        <Grid key={0} item xs={1.98}>
                            <div className={eventClasses.eventDetails2}>Details </div>
                        </Grid>
                        <div className={eventClasses.preferenceFields}></div>
                        <Grid key={1} item xs={1.98}>

                            <DivisionDropDownComp
                                readOnly={readOnlyView}
                                onDivChange={e => onDivDropDownSelect(e)}>
                            </DivisionDropDownComp>
                        </Grid>
                        <Grid key={2} item xs={1.94}>
                            <FormControl style={{ minWidth: '100%' }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="Location*"
                                    onChange={(e) => setStoreLocation(e.target.value)}
                                    value={storeLocation}
                                />
                            </FormControl>
                        </Grid>

                        <Grid key={3} item xs={1.99}>
                            <FormControl style={{ minWidth: '100%' }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="Dropdown X Mins Apart*"
                                    onChange={(e) => setIncrement(e.target.value)}
                                    value={dropDownIncrement}
                                />
                            </FormControl>
                        </Grid>
                        <Grid key={4} item xs={2}>
                        <FormControl style={{ minWidth: '100%' }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="Weeks Out*"
                                    onChange={(e) => setWeeksOut(e.target.value)}
                                    value={weeksOut}
                                />
                            </FormControl>
                        </Grid>
                        <Grid key={5} item xs={2}>

                        </Grid>
                        <Grid key={6} item xs={2}>
                        
                        </Grid>
                        <Grid  item xs={2}>
                        <FormControlLabel
                            value="top"
                            control={
                                <Checkbox
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 34 } }} 
                                onClick={makeLocationActive} 
                                checked = {storeActive}
                                />
                             }
                            label="Location Active"
                            labelPlacement="end"
                            />
                        
                        </Grid>

                        <Grid key={7} item xs={12}></Grid>

                        <Grid item xs={2.02}>
                            <div className={eventClasses.eventDetails2}>New Hires Unlocked </div>
                        </Grid>

                        <Grid item xs={1.98} rowSpacing={2}>
                        <FormControl style={{ minWidth: '100%' }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="New Hire For X Days*"
                                    onChange={(e) => setNewHire(e.target.value)}
                                    value={newHire}
                                />
                            </FormControl>   
                        </Grid>
                        <Grid item xs={8} rowSpacing={2}>
                        </Grid>
                        <Grid item xs={2.02}>
                        </Grid>
                        <Grid item xs={1.98}>
                        <FormControlLabel
                            value="top"
                            control={
                                <Checkbox 
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 34 } }} 
                                onClick={makeNewHireActive} 
                                checked = {newHireActive}
                                />
                            }
                            label="New Hire Active"
                            labelPlacement="end"
                            />
                        </Grid>

                        <Grid item xs={8}>
                        
                        </Grid>
                        <Grid item xs={2.5} columnSpacing={{xs:1}}>
                        <div style={{whiteSpace:"nowrap",marginRight:"30%",fontSize:"25px",}} className={eventClasses.eventDetails2}>Work Schedules </div>
                        <div style={{marginTop:"-2px",marginRight:"30%",fontSize:"25px",}} className={eventClasses.eventDetails2}> Unlocked </div>
                        </Grid>

                        <Grid item xs={6} rowSpacing={2}>
                        <FormControl style={{ minWidth: '100%' ,marginLeft:"-8%" }}>
                                <TextField
                                    inputProps={{ readOnly: readOnlyView }}
                                    label="Work Schedules*"
                                    onChange={(e) => setWorkSchedule(e.target.value)}
                                    value={workSchedule}
                                />
                            </FormControl>   
                        </Grid>
                        <Grid item xs={2.02}>
                        </Grid>
                        <Grid item xs={2.02}>
                        </Grid>
                        <Grid item xs={1.98}>
                        <FormControlLabel
                            value="top"
                            control={
                                <Checkbox 
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 34 } }} 
                                onClick={makeWorkScheduleActive} 
                                checked = {workActive}
                                />
                            }
                            label="Work Schedule Active"
                            labelPlacement="end"
                            />
                        
                        </Grid>
                    </Grid>

                    <Grid container spacing={4} rowSpacing={6}>
                        <Grid key={8} item xs={4}></Grid>
                        <Grid key={9} item xs={2}></Grid>
                        <Grid key={10} item xs={1.99}>
                            <Button onClick={handleCancel} color="secondary" size="large" style={{
                                minWidth: '100%',
                                minHeight: '120%',
                            }}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid key={11} item xs={2}>
                            <Button color="primary" size="large" style={{
                                minWidth: '100%',
                                minHeight: '120%',
                            }} onClick={saveData}>
                                Save
                            </Button>
                        </Grid>
                        <Grid item xs={12}></Grid>
                    </Grid>


                    <SnackBar
                        open={open}
                        message={message}
                        severity={severity}
                        onClose={handleAlertNotifClose}
                    ></SnackBar>
                    {openDeleteDialog && <DeleteEventDialog onCloseDialog={onCloseDialog} onDeleteCallback={onDeleteCallback} divNbr={division} locNbr={storeLocation}  />}
                    {openDuplicateDialog && <DuplicateEventDialog onCloseDialog={onCloseDialog} onDuplicateCallback={onDuplicateCallback}  eventName={eventName} />}

                </div>
                </div>
                
        
        ) // add
    }
}

export default AddEditLocationControls ;